import React from "react";
import { Panel } from "../../Core/Panel/Panel";
import { View } from "react-native";
import { styles, } from "./BigLinkCard.styles";
import { Heading } from "../../Core/Heading/Heading";
import { theme } from "@clearabee/ui-library-base";
export const BigLinkCard = ({ heading, subheading, subheadingColor = "warning", strapline, textColor = "light", image, background = "brand", children, }) => {
    return (React.createElement(Panel, { shadow: true, color: background, styles: styles.wrapper, testID: "bigLinkCardPanel" },
        React.createElement(View, { style: styles.content },
            React.createElement(View, { style: { marginRight: 15 } },
                heading && (React.createElement(Heading, { level: 6, styles: [styles.heading, { color: theme.colors[textColor].base }] }, heading)),
                subheading && (React.createElement(Heading, { fontSize: "xlarge4", styles: [
                        styles.subheading,
                        { color: theme.colors[subheadingColor].base },
                    ] }, subheading)),
                strapline && (React.createElement(Heading, { level: 6, fontSize: "xsmall", styles: [
                        styles.strapline,
                        { color: theme.colors[textColor].base },
                    ] }, strapline))),
            React.createElement(View, { style: styles.image }, image)),
        React.createElement(View, null, children)));
};
//# sourceMappingURL=BigLinkCard.js.map